import { bool, number, shape } from 'prop-types'

import CircleBadge from 'views/components/atoms/CircleBadge'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isDiscountValid } from 'views/utils/productUtils'

const DiscountBadge = props => {
  const {
    discount,
    hasBonus,
    publicRuntimeConfig: {
      publicConfig: { discountBoundaries },
    },
    ...rest
  } = props

  const { bonus } = props
  if (bonus || hasBonus || isDiscountValid(discount, discountBoundaries)) {
    return <CircleBadge {...rest} />
  } else {
    return null
  }
}

DiscountBadge.propTypes = {
  ...CircleBadge.propTypes,
  publicRuntimeConfig: shape({}),
  discount: number,
  bonus: bool,
  hasBonus: bool,
}

DiscountBadge.defaultProps = {
  ...CircleBadge.defaultProps,
  publicRuntimeConfig: {},
  discount: 0,
  bonus: false,
  hasBonus: false,
}

export default withShopAndRuntimeConfig(DiscountBadge)
